import { lazy } from 'react';
import workOrderRoutes from './WorkOrderRoute';

const WorkOrdersPage = lazy(() => import('./WorkOrdersPage'));

const workOrdersRoutes = [
  {
    path: 'work-orders',
    children: [
      { index: true, element: <WorkOrdersPage /> },
      { path: 'past', element: <WorkOrdersPage /> },
      ...workOrderRoutes,
    ],
  },
];

export default workOrdersRoutes;
